function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'researcher/digital-orders/styles/digital-order-payment.scss';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import Loading from 'researcher/components/Loading';
import Redirect from 'shared/components/Redirect';
import useRepeater from 'researcher/hooks/use-repeater';
import { PaymentForm } from 'researcher/payment';
import { T, useTranslate } from 'shared/helper/translate';
import { dateString, DATE_ONLY_FORMAT } from 'researcher/helpers/date';
import { price } from 'researcher/helpers/price';
import { Controls, validators } from 'shared/helper/form';
import { recordTransaction } from 'researcher/helpers/gtm';
import CurrencySelect from 'researcher/order-form/payment/components/CurrencySelect';
import { updateUserCurrencySelection } from 'researcher/user/actions';
import DigitalEditingHeader from './DigitalEditingHeader';
var Checkbox = Controls.Checkbox;
var notFalse = validators.notFalse;
var DigitalEditPayment = function DigitalEditPayment(_ref) {
  var accessType = _ref.accessType,
    allowsDigitalEditing = _ref.allowsDigitalEditing,
    checkForDigitalEditingPurchase = _ref.checkForDigitalEditingPurchase,
    convertNumberOfInstallments = _ref.convertNumberOfInstallments,
    currency = _ref.currency,
    digitalEditEnabled = _ref.digitalEditEnabled,
    availableDigitalPurchases = _ref.availableDigitalPurchases,
    excludePaymentMethods = _ref.excludePaymentMethods,
    hasDigitalEditingPurchase = _ref.hasDigitalEditingPurchase,
    isCurieLaunched = _ref.isCurieLaunched,
    loadDigitalEditing = _ref.loadDigitalEditing,
    newPurchaseStartDate = _ref.newPurchaseStartDate,
    paymentStatus = _ref.paymentStatus,
    purchaseInformation = _ref.purchaseInformation,
    receiptCode = _ref.receiptCode,
    status = _ref.status;
  var dispatch = useDispatch();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    digitalPurchase = _useState2[0],
    setDigitalPurchase = _useState2[1];
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useRepeater = useRepeater({
      fn: function fn() {
        return loadDigitalEditing();
      },
      numberOfSecondsBetweenCalls: 10
    }),
    startUpdating = _useRepeater.start,
    stopUpdating = _useRepeater.stop;
  var userCurrencyIso = useSelector(function (_ref2) {
    var user = _ref2.user;
    return user.currencyIso;
  });
  var handleCurrencySubmission = function handleCurrencySubmission(currencyIso) {
    return dispatch(updateUserCurrencySelection(currencyIso));
  };
  useEffect(function () {
    if (checkForDigitalEditingPurchase) {
      startUpdating();
    }
    return function () {
      return stopUpdating();
    };
  }, []);
  useEffect(function () {
    if (digitalEditEnabled) {
      stopUpdating();
    }
  }, [digitalEditEnabled]);
  useEffect(function () {
    if (!digitalPurchase && availableDigitalPurchases.length > 0) {
      setDigitalPurchase(availableDigitalPurchases[0]);
    }
  }, [availableDigitalPurchases && availableDigitalPurchases.length]);
  useEffect(function () {
    if (purchaseInformation) {
      recordTransaction(purchaseInformation);
    }
  }, [purchaseInformation !== null]);
  if (!digitalPurchase) {
    return /*#__PURE__*/React.createElement(Loading, null);
  }
  if (isCurieLaunched) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/rubriq/plan/subscribe",
      replace: true
    });
  }
  if (!allowsDigitalEditing) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/researcher"
    });
  }
  if (digitalEditEnabled && checkForDigitalEditingPurchase && purchaseInformation) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/researcher/digital-editing"
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container digital-edit-payment"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row pt-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8 col-12"
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    bodyClassName: "bg-gray-lighter",
    title: "Digital Editing"
  }), /*#__PURE__*/React.createElement(DigitalEditingHeader, {
    accessType: accessType,
    busy: status.searchBusy
  }), hasDigitalEditingPurchase && !checkForDigitalEditingPurchase ? /*#__PURE__*/React.createElement("div", {
    className: "alert alert-warning"
  }, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "purchase-digital-editing-existing-subscription"
  })) : null, /*#__PURE__*/React.createElement(T.md, {
    source: "percent-discounted-purchase-digital-editing-overview",
    params: {
      endDate: dateString(t, moment(newPurchaseStartDate).add(1, 'year'), DATE_ONLY_FORMAT),
      price: price(currency, digitalPurchase.price, true, true),
      percent: 30
    }
  }), checkForDigitalEditingPurchase ? /*#__PURE__*/React.createElement("div", {
    className: "alert alert-warning"
  }, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "purchase-digital-editing-loading-notice"
  }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, !userCurrencyIso ? /*#__PURE__*/React.createElement(CurrencySelect, {
    handleCurrencySubmission: handleCurrencySubmission
  }) : null, /*#__PURE__*/React.createElement(PaymentForm, {
    additionalData: {
      availableDigitalPurchaseIdentity: digitalPurchase.identity
    },
    currency: currency,
    convertNumberOfInstallments: convertNumberOfInstallments,
    excludePaymentMethods: excludePaymentMethods,
    paymentsEndpoint: "/api/digital-edit/payment",
    bankTransferDisabled: true,
    receiptCode: receiptCode,
    total: digitalPurchase.price,
    submitDisabled: !userCurrencyIso
  }, /*#__PURE__*/React.createElement(Checkbox, {
    label: function label() {
      return /*#__PURE__*/React.createElement(T.md, {
        inline: true,
        source: "payment-accept-terms-and-conditions"
      });
    },
    name: "acceptedTermsAndConditions",
    styles: {
      wrapper: 'mb-3 mt-3'
    },
    messages: {
      notFalse: 'payment-accept-terms-and-conditions-failure'
    },
    validators: {
      notFalse: notFalse
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: paymentStatus.saving || paymentStatus.loading || !userCurrencyIso,
    className: "btn btn-success btn-squared-large payment-button"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Pay now"
  })), paymentStatus.saving ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null))))));
};
export default DigitalEditPayment;